/* card-gallery — swipe de fotos en la tarjeta de producto.
   - Sólo actúa en dispositivos táctiles (mismo media query que card-gallery.css).
   - Las fotos 2..N vienen con data-cg-src / data-cg-srcset y se cargan cuando la TARJETA se acerca al
     viewport (IntersectionObserver sobre la tarjeta, no sobre la imagen: una imagen recortada por el
     overflow horizontal nunca "interseca" y quedaría en blanco al deslizar).
   - Custom element: se inicializa solo, también tras filtros / paginación AJAX / editor de temas. */
if (!customElements.get('card-gallery')) {
  class CardGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.card-gallery__track');
      this.dots = Array.from(this.querySelectorAll('.card-gallery__dots span'));
      if (!this.track) return;
 
      this.isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
      if (!this.isTouch) return; // escritorio: nada que hacer (overflow hidden por CSS)
 
      this.loaded = false;
      this.onScroll = this.onScroll || this.handleScroll.bind(this);
      this.onTouch = this.onTouch || this.load.bind(this);
 
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.load();
        }, { rootMargin: '400px 0px' });
        this.io.observe(this);
      } else {
        this.load();
      }
      this.track.addEventListener('touchstart', this.onTouch, { passive: true });
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
    }
 
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.track) {
        this.track.removeEventListener('scroll', this.onScroll);
        this.track.removeEventListener('touchstart', this.onTouch);
      }
    }
 
    load() {
      if (this.loaded) return;
      this.loaded = true;
      if (this.io) this.io.disconnect();
      this.querySelectorAll('img[data-cg-src]').forEach((img) => {
        if (img.dataset.cgSrcset) img.srcset = img.dataset.cgSrcset;
        img.src = img.dataset.cgSrc;
        img.removeAttribute('data-cg-src');
        img.removeAttribute('data-cg-srcset');
      });
    }
 
    handleScroll() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        const width = this.track.clientWidth || 1;
        const index = Math.round(this.track.scrollLeft / width);
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      });
    }
  }
  customElements.define('card-gallery', CardGallery);
}